import {
  Box,
  Flex,
  FormBanner,
  FormBannerType,
  IconSize,
  LinkButton,
  LinkButtonType,
  Modal,
  ModalButtons,
  ModalSize,
  OParagraph,
  Spinner,
} from '@lifechurch/react-ion';
import React, { FC } from 'react';
import styled, { useTheme } from 'styled-components';

interface Props {
  dismiss: () => void;
}

const StyledFormBanner = styled(FormBanner)`
  width: 95%;
`;

const OpenPreviewServiceModal: FC<Props> = ({ dismiss }) => {
  const theme = useTheme();
  return (
    <Modal dismiss={dismiss} size={ModalSize.NARROW}>
      <Box mb={5}>
        <StyledFormBanner pr={5} type={FormBannerType.Success} withIcon>
          Content saved.
        </StyledFormBanner>
      </Box>
      <Flex alignItems={'center'} flexDirection={'column'} marginBlockStart={6} width={'100%'}>
        <Spinner color={theme.colors.action.default} size={IconSize.XL} />
        <OParagraph marginBlockStart={5}>Preparing Service</OParagraph>
      </Flex>
      <ModalButtons>
        <Flex justifyContent={'center'} marginBlockStart={5} width={'100%'}>
          <LinkButton buttonType={LinkButtonType.SECONDARY} onClick={dismiss}>
            Cancel
          </LinkButton>
        </Flex>
      </ModalButtons>
    </Modal>
  );
};

export default OpenPreviewServiceModal;
